/**
 * Created by lihanying on 2017/7/14.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBWALLET } from './constants'

export const getClubWallet = (payload) => {
  return {
    type: GETCLUBWALLET,
    payload,
  }
}

//钱包
export function fetchWalletInfo() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/getWalletInfo`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubWallet(data.list))
      return data
    })
  }
}

//提交
export function fetchAddClubMember(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/MemberApi/AddClubMember`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubMember/action.js